import React from 'react'

interface PaperPencilIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const PaperPencilIcon: React.FC<PaperPencilIconProps> = ({
  color = '#000',
  gradient = false,
  width = 24,
  height = 24,
  alt = 'Paper pencil icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      aria-label={alt}
      viewBox='0 0 33 33'
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <mask
        id='mask0'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='33'
        height='33'
      >
        <path d='M32.887 0.951477H0.95166V32.8868H32.887V0.951477Z' fill='white' />
      </mask>
      <g
        mask='url(#mask0)'
        stroke={gradient ? 'url(#grad1)' : color}
        strokeWidth='1.27016'
        strokeMiterlimit='10'
      >
        <path d='M14.4819 24.7129L7.86621 26.0361L9.18934 19.4203L22.9797 5.63007L28.2722 10.9227L14.4819 24.7129Z' />
        <path d='M28.2726 10.9226L22.98 5.63001L26.2879 2.32215L31.5804 7.61474L28.2726 10.9226Z' />
        <path d='M20.3335 8.27637L25.6262 13.569' />
        <path d='M9.18994 19.4204L13.821 20.082L14.4825 24.713' />
        <path d='M22.9801 10.9227L13.8208 20.082' />
        <path d='M16.9814 22.2138V31.8905H2.01172V16.9208H11.6884' />
        <path d='M19.7881 31.8904H28.2085' />
        <path d='M19.7881 28.1479H32.8866' />
        <path d='M19.7881 24.4056H32.8866' />
      </g>
    </svg>
  )
}

export default PaperPencilIcon
